﻿<div>
    <busy-indicator *ngIf="!isLoaded" big="true"></busy-indicator>

    <div *ngIf="isLoaded">
        <div *ngFor="let cardData of details" class="contentRow">

            <mat-divider></mat-divider>

            <div fxFlex>
                <span *ngIf="cardData.Title" [ngClass]="colorClass">{{cardData.Title}}</span>
                <span *ngIf="cardData.SubHeader" [ngClass]="colorClass">{{cardData.SubHeader}} &bull; </span>
                <span *ngIf="cardData.Description" [ngClass]="colorClass"> {{cardData.Description}}</span>

                <div fxLayout="row" layout-wrap>
                    <div *ngFor="let dataElement of getVisibleDataElements(cardData)" fxFlex>
                        <labeled-field [label]="dataElement.Label">
                            <truncate-text [mainText]="dataElement.Value">
                            </truncate-text>
                        </labeled-field>
                    </div>
                </div>

                <br>

                <table class="full-table">

                    <tr *ngFor="let dataElement of getVisibleHeaderElements(cardData); index as i">
                        <ng-container *ngFor="let data of getLabelParts(dataElement)">
                            <td [ngStyle]="getHeaderAlignStyle(i)">
                                {{data}}
                            </td>
                        </ng-container>
                    </tr>

                    <tr *ngFor="let dataElement of getVisibleRowElements(cardData)">
                        <ng-container *ngFor="let data of getValueParts(dataElement)">
                            <td [ngStyle]="getDataAlignStyle(data)">
                                <truncate-text [mainText]="data">
                                </truncate-text>
                            </td>
                        </ng-container>
                    </tr>
                </table>
            </div>
            <mat-divider></mat-divider>
        </div>
    </div>
</div>